import { styled } from '@mui/material/styles';

export const Container = styled('div')`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 10px;
`

export const DropzoneContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 5%;
  height: 200px;
  width: 100%;
  text-align: center;
  border: dashed;
  border-color: ${(props) => props.theme.palette.grey[400]};
  cursor: pointer;
  margin: 2% 0% 2% 0%;
`;

export const Input = styled('input')`
  display: none;
`;